import React, { Component } from 'react';

import { getGesturePointFromEvent } from './Tools.js'

import './SwipeHandler.css';

// Global state variables for SWIPE

//FROM : https://developers.google.com/web/fundamentals/design-and-ux/input/touch/


class SwipeHandler extends Component {


    constructor(props) {

        super(props);       
        
        this.initialTouchPos = null;
        this.lastTouchPos = null;
        this.rafPending = false;

        this.handlerDom = null;
        this.setHandlerDom = element => {
            this.handlerDom = element;
        };    

        this.handleGestureStart = this.handleGestureStartFn.bind(this);
        this.handleGestureEnd = this.handleGestureEndFn.bind(this);
        this.handleGestureMove = this.handleGestureMoveFn.bind(this);        

        /* for swipe */
        this.currentPosition = {x: 0, y: 0};
        this.currentSwipeState = false; // default state */

    }



    componentDidMount() 
    {

        // Add Touch Listener
        this.handlerDom.addEventListener('touchstart', this.handleGestureStart, true);
        this.handlerDom.addEventListener('touchmove', this.handleGestureMove, true);
        this.handlerDom.addEventListener('touchend', this.handleGestureEnd, true);
        this.handlerDom.addEventListener('touchcancel', this.handleGestureEnd, true);
    
        // Add Mouse Listener
        this.handlerDom.addEventListener('mousedown', this.handleGestureStart, true);

        /* add variables */

        this.itemWidth = this.handlerDom.clientWidth;
        this.slopValue = this.itemWidth * (1/4);
        this.handleSize = 10;   
        
       
    }    


    componentWillUnmount()
    {
    
        // Remove Touch Listener
        this.handlerDom.removeEventListener('touchstart', this.handleGestureStart);
        this.handlerDom.removeEventListener('touchmove', this.handleGestureMove);
        this.handlerDom.removeEventListener('touchend', this.handleGestureEnd);
        this.handlerDom.removeEventListener('touchcancel', this.handleGestureEnd);

        // Remove Mouse Listener
        this.handlerDom.removeEventListener('mousedown', this.handleGestureStart);
    }
        
    
    componentDidUpdate(prevProps, prevState, snapshot)
    {

    }

    shouldComponentUpdate(nextProps, nextState)
    {
        return true;
    }

    /* ----------------------------------------------- */

    // Handle the start of gestures
    handleGestureStartFn(evt) {
        evt.preventDefault();

      //  this.props.logFn('SwipeHandler:handleGestureStartFn');
    
        if(evt.touches && evt.touches.length > 1)   return;
    
        // Add the move and end listeners
        if (this.handlerDom) {       
            // Add Mouse Listeners
            this.handlerDom.addEventListener('mousemove',this.handleGestureMove, true);
            this.handlerDom.addEventListener('mouseup', this.handleGestureEnd, true);
        }
    
        this.initialTouchPos = getGesturePointFromEvent(evt);    

    };

    // Handle end gestures
    handleGestureEndFn(evt) {
        evt.preventDefault();

       // this.props.logFn('SwipeHandler:handleGestureEndFn');
    
        if(evt.touches && evt.touches.length > 0)   return;
    
        this.rafPending = false;
    
        // Remove Event Listeners
        if (this.handlerDom) {
            // Remove Mouse Listeners
            this.handlerDom.removeEventListener('mousemove', this.handleGestureMove, true);
            this.handlerDom.removeEventListener('mouseup', this.handleGestureEnd, true);
        }
    
        this.updateSwipeRestPosition();
    
        this.initialTouchPos = null;
    }

    handleGestureMoveFn(evt) {
        evt.preventDefault();

       // this.props.logFn('SwipeHandler:handleGestureMoveFn');
      
        if(!this.initialTouchPos)  return;
        
        this.lastTouchPos = getGesturePointFromEvent(evt);
      
        if(this.rafPending)  return;    
      
        this.rafPending = true;
    }


    updateSwipeRestPosition = () => {

        this.props.logFn('SwipeHandler:updateSwipeRestPosition');

        if( !this.lastTouchPos || !this.initialTouchPos ) return;

        // Go to the default state and change
        let newState = false;        

        const swn = this.props.swipeNeed;
        if( (swn == "swipe_left") || (swn == "swipe_right") )
        {
            let dX = this.initialTouchPos.x - this.lastTouchPos.x;

            // Check if we need to change state to left or right based on slop value
            if(Math.abs(dX) > this.slopValue) 
            {
                if(this.currentSwipeState === false) {
                    if(dX > 0) {
                        newState = 'swipe_left';
                    } else {
                        newState = 'swipe_right';
                    }
                } else {
                    if(this.currentSwipeState === 'swipe_left' && dX > 0) {
                        newState = false;
                    } else if(this.currentSwipeState === 'swipe_right' && dX < 0) {
                        newState = false;
                    }
                }
            } else {
               newState = this.currentSwipeState;
            }
        }else // (swn == "swipe_up") || (swn == "swipe_down") )
        {
            let dY = this.initialTouchPos.y - this.lastTouchPos.y;

            // Check if we need to change state to left or right based on slop value
            if(Math.abs(dY) > this.slopValue) 
            {
                if(this.currentSwipeState === false) {
                    if(dY > 0) {
                        newState = 'swipe_up';
                    } else {
                        newState = 'swipe_down';
                    }
                } else {
                    if(this.currentSwipeState === 'swipe_up' && dY > 0) {
                        newState = false;
                    } else if(this.currentSwipeState === 'swipe_down' && dY < 0) {
                        newState = false;
                    }
                }
            } else {
                newState = this.currentSwipeState;
            }        
        }

        this.currentSwipeState = newState;

        if(this.props.onEnd && ( this.props.swipeNeed == this.currentSwipeState))
            this.props.onEnd( newState );

    }    

    
    render() {

        const children = this.props.children;

        let cl = 'SwipeHandler';
        if(window._DEBUG_TOUCH) cl += ' debugTouch ';

        return (
            <div className={ cl } ref={ this.setHandlerDom } >
                {children}
            </div>
        );    
  }
}



//----------------------------------------------------------------------------

export default SwipeHandler;



// WEBPACK FOOTER //
// ./src/SwipeHandler.js